import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const socialActionsBlock = style([
  {
    display: 'flex',
    gap: space.s10,
  },
]);

export const streamFollowers = style([
  {
    selectors: {
      '&:is(&)': {
        ...typography.labelMd,
      },
    },
  },
]);
